class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      console.log(`submit`, e);
      e.preventDefault();

      const formData = new FormData(this.form);

      const selectedVariant = formData.get("id");

      if ("requireSelect" in this.dataset && !selectedVariant) {
        this.innerHTML = this.dataset.requireSelect;
        return;
      }

      if (this._secondary) return;

      const allowedKeys = ["id", "quantity"];
      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

        if (property || allowedKeys.includes(name)) {
          if (!property) {
            data[name] = value;
          } else {
            if (!("properties" in data)) {
              data.properties = {};
            }
            data.properties[property.groups.propertyKey] = value;
          }
        }
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      data.quantity = parseInt(data.quantity);

      window.addToCart(data, {
        onError: (response) => {
          this.showError(
            response?.message ||
              window.theme.localeStrings.product.add_to_cart_error,
          );
        },
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }

  showError(message) {
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.innerHTML = message;

    this.form.append(error);

    setTimeout(() => {
      error.remove();
    }, 3000);
  }

  get _secondary() {
    return this.hasAttribute("secondary");
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
